<form class="report-details-form" [formGroup]="form" *ngIf="!isLoading else loadingAnimation">
    <app-input-datepicker class="evaluation-date" *ngIf="isManualMeasurement"
                          [formControl]="control('measurementDate')"
                          label="{{'admin.strain.tickets.reports.modal.step2.measurementDate' | translate}}"
                          placeholder="{{'admin.strain.tickets.reports.modal.step2.measurementDate' | translate}}"
                          [showErrors]="showValidations">
    </app-input-datepicker>

    <app-dropdown-autocomplete *ngIf="isManualMeasurement"
                               class="evaluated-by"
                               valueField="id"
                               displayField="name"
                               label="{{'admin.strain.tickets.reports.modal.step2.measurementBy' | translate}}"
                               emptyText="{{'admin.strain.tickets.reports.modal.step2.measurementBy' | translate}}"
                               [formControl]="control('measurementBy')"
                               [items]="users"
                               [showErrors]="showValidations || control('measurementBy').touched && control('measurementBy').invalid">
    </app-dropdown-autocomplete>

    <app-dropdown-autocomplete
        class="frequency"
        valueField="id"
        displayField="displayName"
        label="{{'admin.strain.tickets.reports.modal.step2.sampleRate' | translate}}"
        emptyText="{{'admin.strain.tickets.reports.modal.step2.sampleRate' | translate}}"
        [formControl]="control('frequency')"
        [items]="frequencies"
        [showErrors]="showValidations || control('frequency').touched && control('frequency').invalid">
    </app-dropdown-autocomplete>

    <app-dropdown-autocomplete
        class="measuringEquipment"
        valueField="id"
        displayField="name"
        label="{{'admin.strain.tickets.reports.modal.step2.measurementEquipment' | translate}}"
        emptyText="{{'admin.strain.tickets.reports.modal.step2.measurementEquipment' | translate}}"
        [formControl]="control('measuringEquipment')"
        [items]="measuringEquipment"
        [showErrors]="showValidations || control('measuringEquipment').touched && control('measuringEquipment').invalid">
    </app-dropdown-autocomplete>

    <app-input
        class="responsible"
        [formControl]="control('responsible')"
        [showErrors]="showValidations || control('responsible').touched && control('responsible').invalid"
        label="{{'admin.strain.tickets.reports.modal.step2.responsible' | translate}}"
        [placeholder]="'admin.strain.tickets.reports.modal.step2.responsible' | translate">
    </app-input>

    <app-dropdown-autocomplete
        class="testType"
        valueField="id"
        displayField="name"
        label="{{'admin.strain.tickets.reports.modal.step2.testType' | translate}}"
        emptyText="{{'admin.strain.tickets.reports.modal.step2.testType' | translate}}"
        [formControl]="control('measurementType')"
        [items]="measurementTypes"
        [showErrors]="showValidations || control('measurementType').touched && control('measurementType').invalid">
    </app-dropdown-autocomplete>

    <label class="label"> {{ 'admin.strain.tickets.reports.modal.step2.mediumPlaceholder' | translate }}</label>
    <div class="inline">
        <app-input
            class="temperature"
            type="number"
            [allowNegative]="true"
            mask="separator.2"
            [formControl]="control('temperature')"
            [showErrors]="showValidations || control('temperature').touched && control('temperature').invalid"
            label="{{'admin.strain.tickets.reports.modal.step2.temperature' | translate}}"
            [placeholder]="'admin.strain.tickets.reports.modal.step2.temperature' | translate">
        </app-input>

        <app-input
            type="number"
            class="humidity"
            [allowNegative]="true"
            mask="separator.2"
            [formControl]="control('humidity')"
            [showErrors]="showValidations || control('humidity').touched && control('humidity').invalid"
            label="{{'admin.strain.tickets.reports.modal.step2.humidity' | translate}}"
            [placeholder]="'admin.strain.tickets.reports.modal.step2.humidity' | translate">
        </app-input>
    </div>

    <app-dropdown-autocomplete
        class="executionMode"
        valueField="id"
        [appendTo]="'body'"
        displayField="name"
        emptyText="{{'admin.strain.tickets.reports.modal.step2.executionMode' | translate}}"
        label="{{'admin.strain.tickets.reports.modal.step2.executionMode' | translate}}"
        [formControl]="control('measurementMethod')"
        [items]="measurementMethods"
        [showErrors]="showValidations || control('measurementMethod').touched && control('measurementMethod').invalid">
    </app-dropdown-autocomplete>

</form>
<ng-template #loadingAnimation>
    <app-loading-spinner class="loader"></app-loading-spinner>
</ng-template>
